"use strict";
/* eslint-disable no-lonely-if, brace-style */

Object.defineProperty(exports, "__esModule", {
  value: true
});
var povertyGuidelines = {
  AK: [18810, 25540, 32270, 39000, 45730, 52460, 59190, 65920],
  HI: [17310, 23500, 29690, 35880, 42070, 48260, 54450, 60640],
  US: [15060, 20440, 25820, 31200, 36580, 41960, 47340, 52720]
};

function getStatePovertyLevel(dirtyState, persons) {
  var multiplier = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var period = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "monthly";
  if (!dirtyState) throw new Error("Missing State");
  if (!persons) throw new Error("Missing Persons Count");
  var state = dirtyState.toUpperCase();
  var guidelines = povertyGuidelines[state] || povertyGuidelines["US"];
  var cutoff;

  if (persons <= 8) {
    cutoff = guidelines[persons - 1];
  } else {
    var additionalPersonRate = state === "AK" ? 6730 : state === "HI" ? 6190 : 5380;
    cutoff = guidelines[7] + additionalPersonRate * (persons - 8);
  }

  var annualCutoff = cutoff * multiplier;
  return period === "monthly" ? parseFloat((annualCutoff / 12).toFixed(2)) : parseFloat(annualCutoff.toFixed(2));
}

exports.default = getStatePovertyLevel;